import React from 'react'
import { Helmet } from 'react-helmet'
import GoalForm from './GoalForm'
import { Container } from '@material-ui/core'
import { ModernCard } from 'components/Cards'

const GoalEdit = () => {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Edit Goal | Express Evaluations</title>
      </Helmet>
      <Container style={{ marginTop: '32px' }}>
        <ModernCard headerTitle="Edit Goal">
          <GoalForm />
        </ModernCard>
      </Container>
    </div>
  )
}

export default GoalEdit
